import styled from 'styled-components';

const StyledWrapper = styled.div`
  width: 120px;
  display: flex;
  flex-direction: column;
`;
const StyledItem = styled.span`
  font-size: 8px;
  text-transform: uppercase;
  color: #747d93;
  margin-bottom: 13px;
`;
const Leyend = ({ items, className }) => {
  return (
    <StyledWrapper className={className}>
      {items?.map(i => (
        <StyledItem>{i}</StyledItem>
      ))}
    </StyledWrapper>
  );
};

export default Leyend;
